import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@glowforge/gf-styled/components/contentful-views';
import { Paragraph } from '@glowforge/gf-styled/components/typography/Typography';
import { ButtonLinkWidget } from '@glowforge/gf-styled/contentful-widgets';

import {
  ButtonLinkWrapper,
  CardBackground,
  CardContent,
  CardLink,
  CardWrapper,
  LogoImage,
  ProductInfo,
  TopImage,
  TopImageInnerWrapper,
} from './meet-the-family-rebrand.styles';
import { contentfulImageShape } from '../../util/contentful-data';

const MeetTheFamilyDesktop = ({ productsLink, product }) => (
  <CardLink href={productsLink}>
    <CardWrapper imgHeight={263}>
      <CardBackground />
      <TopImage>
        <TopImageInnerWrapper>
          <Image media={product.productPhoto} lazy />
        </TopImageInnerWrapper>
      </TopImage>
      <CardContent>
        <ProductInfo>
          <LogoImage svgAsset={product.logoPhoto} height={47} noWidth />
          <Paragraph>{product.subtitle}</Paragraph>
          <ButtonLinkWrapper>
            <ButtonLinkWidget model={product.ctaButton} />
          </ButtonLinkWrapper>
        </ProductInfo>
      </CardContent>
  </CardWrapper>
  </CardLink>
);

MeetTheFamilyDesktop.propTypes = {
  productsLink: PropTypes.string.isRequired,
  product: PropTypes.shape({
    productPhoto: contentfulImageShape,
    logoPhoto: contentfulImageShape,
    subtitle: PropTypes.string,
    ctaButton: PropTypes.shape({}),
  }).isRequired,
};

export default MeetTheFamilyDesktop;
